(() => {
  if (window.gfPaymentComparisonLoaded) return;
  window.gfPaymentComparisonLoaded = true;
  const initialized = new WeakSet();
  const money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  const preciseMoney = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const init = () => document.querySelectorAll('product-info.gf-mobile-product').forEach((section) => {
    if (initialized.has(section) || !section.querySelector('.gf-payment-options')) return;
    initialized.add(section);
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const card = section.querySelector('.gf-payment-options');
      if (!card) return;
      const script = section.querySelector('variant-selects [data-selected-variant]');
      let variant;
      try { variant = script ? JSON.parse(script.textContent) : { price: Number(card.dataset.variantPrice), available: card.dataset.variantAvailable === 'true' }; }
      catch { variant = null; }
      const visible = !!variant?.available && Number.isFinite(variant.price) && variant.price >= 0;
      if (card.hidden === visible) card.hidden = !visible;
      if (!visible) return;
      const setting = (key, fallback) => {
        const value = Number(card.dataset[key]);
        return Number.isFinite(value) && value >= 0 ? Math.round(value) : fallback;
      };
      const fee = variant.price < setting('feeThreshold', 50000) ? setting('feeLow', 9100) : setting('feeHigh', 10100);
      const discount = Math.min(variant.price, setting('prepaidDiscount', 3100));
      const total = variant.price + fee;
      const percentSetting = Number(card.dataset.advancePercent);
      const percent = Number.isFinite(percentSetting) ? Math.min(100, Math.max(0, percentSetting)) : 50;
      const advanceBasis = card.dataset.percentIncludeCod === 'true' ? total : variant.price;
      const requestedAdvance = variant.price > setting('advancePercentThreshold', 200000)
        ? Math.round(advanceBasis * percent / 100) : setting('advanceAmount', 50000);
      const advanceAmount = Math.min(total, Math.max(0, requestedAdvance));
      const format = amount => (amount % 100 === 0 ? money : preciseMoney).format(amount / 100);
      const put = (selector, text) => { const element = card.querySelector(selector); if (element && element.textContent !== text) element.textContent = text; };
      const message = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.split('__'+key+'__').join(value), template || '');
      put('[data-gf-cod-price]', format(total));
      put('[data-gf-fee]', message(card.dataset.feeText, {fee: format(fee)}));
      put('[data-gf-saving]', message(card.dataset.savingText, {saving: format(fee + discount)}));
      put('[data-gf-advance]', message(card.dataset.advanceText, {advance: format(advanceAmount), balance: format(total - advanceAmount)}));
      const advance = card.querySelector('[data-gf-advance]');
      const showAdvance = variant.price > setting('advanceThreshold', 100000) && advanceAmount > 0;
      if (advance && advance.hidden === showAdvance) advance.hidden = !showAdvance;
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
    const observer = new MutationObserver(schedule);
    observer.observe(section, { childList: true, subtree: true, characterData: true });
    const cleanup = (event) => {
      if (event.detail?.sectionId !== section.dataset.section) return;
      observer.disconnect(); initialized.delete(section);
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

